document.addEventListener('DOMContentLoaded', async function () {
  const portfolioProjectsElement = document.getElementById('portfolio_projets');
  const childFiltersElement = document.getElementById('filtres_enfants');
  const switchElement = document.querySelector('#switch');
  let adminAjaxURL = switchElement.getAttribute('data-ajaxurl');
  const filtersLoader = document.getElementById('loader-filtres');
  const projectsLoader = document.getElementById('loader-projets');
  const voirPlusButton = document.getElementById('voir_plus');
  let offset = 0;

  async function postData(url, formData) {
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData,
      });
      return await response.json();
    } catch (error) {
      console.error('Error:', error);
    }
  }

  async function loadChildFilters(parentCategory) {
    setTimeout(() => {
      filtersLoader.style.display = 'block';
    }, 100);
    const formData = new URLSearchParams({
      action: 'load_child_filters',
      parent_category: parentCategory,
    });
    const response = await postData(adminAjaxURL, formData);
    if (response.error) {
      console.error(response.error);
      return;
    }
    childFiltersElement.innerHTML = response.filters_html;
    filtersLoader.style.display = 'none';
  }

  async function loadProjects(
    parentCategory,
    typeProjet = ['all'],
    isChildFilter = false,
    resetOffset = false
  ) {
    if (resetOffset) {
      offset = 0; // Réinitialiser l'offset si nécessaire
      portfolioProjectsElement.innerHTML = ''; // Nettoyer les projets précédents si on réinitialise
    }
    setTimeout(() => {
      projectsLoader.style.display = 'block';
    }, 100);
    const formData = new URLSearchParams({
      action: 'load_projects',
      type: JSON.stringify(typeProjet),
      parent_category: parentCategory,
      is_child_filter: isChildFilter,
      offset: offset, // Envoyer l'offset actuel
    });
    const response = await postData(adminAjaxURL, formData);
    if (response.error) {
      console.error(response.error);
      return;
    }
    portfolioProjectsElement.insertAdjacentHTML(
      'beforeend',
      response.projects_html
    ); // Ajouter les nouveaux projets
    offset += 9; // Augmenter l'offset pour la prochaine charge

    // Show or hide the "Voir Plus" button based on the total number of projects
    if (offset >= response.total_projects) {
      voirPlusButton.style.display = 'none';
    } else {
      voirPlusButton.style.display = 'block';
    }

    projectsLoader.style.display = 'none';
  }

  switchElement.addEventListener('change', function () {
    const parentCategory = this.checked ? 'professionnel' : 'particulier';
    loadChildFilters(parentCategory);
    loadProjects(parentCategory, ['all'], false, true);
  });

  document.addEventListener('click', async function (e) {
    if (e.target && e.target.matches('.filtres__enfants button')) {
      // Remove 'selected' class from all buttons
      document.querySelectorAll('.filtres__enfants button').forEach((btn) => {
        btn.classList.remove('selected');
      });
      // Add 'selected' class to the clicked button
      e.target.classList.add('selected');
      const selectedType = e.target.getAttribute('data-type');
      loadProjects(
        switchElement.checked ? 'professionnel' : 'particulier',
        selectedType ? [selectedType] : ['all'],
        true,
        true // Réinitialiser l'offset lors du changement de filtre
      );
    }
  });

  voirPlusButton.addEventListener('click', function () {
    loadProjects(
      switchElement.checked ? 'professionnel' : 'particulier',
      Array.from(
        document.querySelectorAll('.filtres__enfants button.selected'),
        (btn) => btn.getAttribute('data-type')
      ),
      true,
      false // Ne pas réinitialiser l'offset lors du chargement de plus de projets
    );
  });

  // Trigger the change event manually to load initial data
  switchElement.dispatchEvent(new Event('change'));
});
